import { Reveal } from './Reveal';

const LINES = [
  'de terminer votre journée devant une pile de formulaires.',
  "de chercher une information qui existe déjà.",
  'de ressaisir les mêmes données encore et encore.',
  "de consacrer votre temps à transporter l'information plutôt qu'à vivre votre vie.",
];

export const Manifesto = () => (
  <section className="bg-[#0B0F19] py-28 md:py-44" data-testid="manifesto-section">
    <div className="max-w-5xl mx-auto px-6 sm:px-10 space-y-10 md:space-y-14">
      {LINES.map((l, i) => (
        <Reveal key={i} className="text-2xl sm:text-3xl lg:text-4xl leading-snug text-slate-400 font-light">
          <span className="text-white font-medium">Vous méritez mieux</span> que {l}
        </Reveal>
      ))}
      <Reveal className="pt-16 md:pt-24 border-t border-white/10">
        <p className="text-xl sm:text-2xl text-slate-400 font-light">Parce qu'au bout du compte, ce n'est pas votre travail qui vous manque.</p>
        <p className="font-heading text-4xl sm:text-5xl lg:text-6xl uppercase font-bold tracking-tight text-amber-400 mt-4 leading-none" data-testid="manifesto-closing">
          Ce sont les moments que vous manquez à cause de lui.
        </p>
      </Reveal>
    </div>
  </section>
);
